import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Margin, Text, Grid, Row, Col } from 'shared/components'
import { auth } from 'routes/route.map'
import { ROLES } from 'constants/account.roles'

import { TransitionLink } from 'local/components'

import UserForm from './components/userForm'
import Step1Form from './components/step1Form'
import Step2Form from './components/step2Form'

import * as styles from './styles'

const NewSignupComponent = ({ onSubmit }) => {
  const [currentStep, setCurrentStep] = useState(1)
  const [step1Data, setStep1Data] = useState(null)

  const handleStep1Submit = (formData) => {
    setStep1Data(formData)
    setCurrentStep(2)
  }

  const handleStep2Submit = (formData) => {
    const completeData = {
      ...step1Data,
      address: formData.address
    }
    onSubmit({ type: ROLES.USER, entity: completeData })
  }

  const handleStep2Skip = () => {
    // Skip step 2 and submit only step 1 data
    onSubmit({ type: ROLES.USER, entity: step1Data })
  }

  const handleBackToStep1 = () => {
    setCurrentStep(1)
  }

  return (
    <>
      {/* Mobile and Tablet View */}
      <div css={styles.mobileView}>
        {currentStep === 1 ? (
          <Step1Form onSubmit={handleStep1Submit} />
        ) : (
          <Step2Form
            onComplete={handleStep2Submit}
            onSkip={handleStep2Skip}
            onBack={handleBackToStep1}
          />
        )}
      </div>

      {/* Desktop View */}
      <div css={styles.desktopView}>
        <Grid>
          <Row middle="xs" css={styles.signupContainer}>
            <Col lg={4} xs={0}>
              <img src="./img/newAuth/signup.png" css={styles.signUpImgBanner} />
            </Col>
            <Col lg={2} xs={0} />
            <Col lg={4} xs={12}>
              <section css={styles.signupSection}>
                <div css={styles.formInfo}>
                  <Margin bottom={2}>
                    <Text as="h2" size={16} white italic bold>
                      Sign Up
                    </Text>
                  </Margin>

                  <TransitionLink
                    text="Already have an account?"
                    linkText="Log in"
                    to={auth.login()}
                    size={11}
                  />
                </div>
                <Margin as="section" tb={2}>
                  <UserForm onSubmit={onSubmit} />
                </Margin>
              </section>
            </Col>
            <Col lg={2} xs={0} />
          </Row>
        </Grid>
      </div>
    </>
  )
}

NewSignupComponent.propTypes = {
  onSubmit: PropTypes.func.isRequired,
}

export default NewSignupComponent
